import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function POST(req: Request) {
  const { shop_name, user_name, pin } = await req.json()

  const shopId = uuid()
  await query('INSERT INTO shops (id, name) VALUES (?, ?)', [shopId, shop_name])

  const userId = uuid()
  await query(
    'INSERT INTO shop_users (id, shop_id, name, pin, role) VALUES (?, ?, ?, ?, ?)',
    [userId, shopId, user_name, pin, 'patron']
  )

  const shop = await queryOne('SELECT * FROM shops WHERE id = ?', [shopId])
  const user = await queryOne(
    'SELECT id, shop_id, name, role, created_at FROM shop_users WHERE id = ?',
    [userId]
  )

  return NextResponse.json({ shop, user })
}
